export default __webpack_public_path__ + "static/media/lk_2.e440145a.jpg";